import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { AccountsService } from "./accounts.service";
import { UsersService } from "../users/users.service";
import { ProjectsService } from "../projects/projects.service";
import * as moment from "moment";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "usersdetail-component",
  template: require('./userdetail.component.html'),
  styles: [require('./userdetail.component.scss')]
})
export class UserDetailComponent implements OnInit {
  account: any;
  accountProjects: any[] = [];
  comboProjects: any[] = []; //all account projects and user projects (project permissions)
  activePanels: string[] = ["users", "project-permissions"];
  reverse: boolean = false;
  predicate: string = "created_at";
  onlyActive: boolean = true;
  users: any[] = [];
  itemsPerPageValues: number[];
  itemsPerPage: number = 10;
  getFieldOrderBy: Function;
  dialog: any = null;
  projects: any[] = [];
  user: any;
  chosenProject: any = {};
  selectedProject: any = {};
  selectedPermissionId: number;
  sent: boolean = false;
  @ViewChild("editUserModalTemplate")
  private editUserModalComponent: TemplateRef<any>;
  @ViewChild("editProjPermissionModalTemplate")
  private editProjPermissionModalComponent: TemplateRef<any>;

  constructor(
    private service: UsersService,
    private router: Router,
    private modalService: NgbModal,
    private projectService: ProjectsService
  ) {}

  ngOnInit() {
    this.account = AccountsService.currentAccount;
    this.user = UsersService.currentUser;

    if (!this.account || !this.user) {
      this.router.navigate(["/accounts"]);
    } else {
      this.getProjects(); //get the projects linked to the account
      this.service.getUsers(this.account.id).subscribe((users) => {
        this.users = users;
        this.sortBy("it.created_at", "created_at");
      });

      this.itemsPerPageValues = this.service.getItemsPerPageValues();
      this.itemsPerPage = this.service.getItemsPerPage();

      // Comparing the Objects by creating Lookup Object for Easy Iteration
      // (id-object(account project) is the key value pair in accountProjectLookup object)
      const accountProjectLookup = {};
      this.accountProjects.forEach(function (project) {
        accountProjectLookup[project.id] = project;
      });

      // iterate through the User projects
      // if the User Project Id matches with the Account projects Id then get all the User Project details
      Object.keys(accountProjectLookup).forEach((projId) => {
        const project = this.user.projects
          ? this.user.projects.find((proj) => proj.id === projId)
          : false;
        if (project) {
          this.comboProjects = [
            ...(this.comboProjects ? this.comboProjects : []),
            {
              ...project,
              permstatus: project.permstatus ? project.permstatus : false
            }
          ];
        } else {
          const picked = (({ name, id, role }) => ({
            name,
            id,
            role: role ? role : "none",
            permstatus: false
          }))(accountProjectLookup[projId]);
          this.comboProjects = [
            ...(this.comboProjects ? this.comboProjects : []),
            picked
          ];
        }
      });
    }
  }

  getProjects() {
    this.service.getProjects().subscribe((projects) => {
      this.projects = projects;

      this.accountProjects = this.projects.filter((it) => {
        const result = AccountsService.currentAccount.project_ids.includes(
          it.id
        );
        return result;
      });
    });
  }

  sortBy(getField: string, fieldName: string) {
    this.reverse = !this.reverse;
    this.reverse = this.predicate === fieldName ? this.reverse : false;
    this.predicate = fieldName;
    this.getFieldOrderBy = new Function(
      "it",
      `return (${getField} || '').toString().toLowerCase();`
    );
  }

  formatDate(date: any) {
    return moment(date).format("DD/MM/YYYY hh:mm A");
  }

  editUser(user: any) {
    UsersService.currentUser = user;
    this.router.navigate(["/edituser"]);
  }

  showEditUserModal() {
    if (!this.sent) {
      this.dialog = this.modalService.open(this.editUserModalComponent);
    }
  }

  editUserFromModal(result) {
    this.dialog.close();
    if (result) {
      //If user clicked Yes, then edit the user by calling onEditSubmit()
      this.onEditSubmit();
    }
  }

  back() {
    window.history.back();
  }

  onEditSubmit() {
    this.activePanels = [];
    if (!this.sent) {
      this.sent = true;
      this.service.editUser(this.user).subscribe(
        (res) => {
          this.back();
        },
        (error) => {
          this.sent = false;
          setTimeout(() => {
            this.activePanels = ["details"];
          }, 1);
        }
      );
    }
  }

  //Modal to Edit Project Permission
  showEditProjPermModal(projectObj) {
    this.chosenProject = projectObj;
    if (!this.sent) {
      this.dialog = this.modalService.open(
        this.editProjPermissionModalComponent
      );
    }
  }

  editProjPermModalSubmit(result) {
    if (result) {
      const projects = this.comboProjects.map((proj) => {
        const contain = this.user.projects
          ? this.user.projects.find((pr) => pr.id === proj.id)
          : false;

        if (proj.id === this.chosenProject.id) {
          return {
            id: this.chosenProject.id,
            name: this.chosenProject.name,
            role: this.chosenProject.role,
            permstatus: this.chosenProject.permstatus,
            isDelete: contain ? true : false,
            isNew: true
          };
        } else {
          return {
            id: proj.id,
            name: proj.name,
            role: proj.role,
            permstatus: proj.permstatus
          };
        }
      });

      const usr = {
        ...this.user,
        projects: projects
      };

      this.service.editUser(usr).subscribe((data) => {
        this.dialog.close();
      });
    } else {
      this.dialog.close();
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/accounts/userdetail.component.ts